import { cyan, cyan_200, cyan_400, green, green_200, green_500, indigo, indigo_300, indigo_600, lime, lime_200, lime_500, magenta, magenta_300, magenta_700, orange, orange_200, orange_500, pink, pink_200, pink_600, purple, purple_200, purple_600, red, red_300, red_600, sky, sky_300, sky_600, teal, teal_300, teal_500, yellow, yellow_200, yellow_400 } from '@panwds/constants';
/** @deprecated use data vis colors instead */
export const CATEGORY_1_SHIFT_LIGHT_COLORS = {
    1: sky,
    2: orange,
    3: teal,
    4: purple,
    5: yellow,
    6: magenta,
    7: sky_300,
    8: orange_200,
    9: teal_300,
    10: purple_200,
    11: yellow_200,
    12: magenta_300
};
/** @deprecated use data vis colors instead */
export const CATEGORY_1_SHIFT_DARK_COLORS = {
    1: sky,
    2: orange,
    3: teal,
    4: purple,
    5: yellow,
    6: magenta,
    7: sky_600,
    8: orange_500,
    9: teal_500,
    10: purple_600,
    11: yellow_400,
    12: magenta_700
};
/** @deprecated use data vis colors instead */
export const CATEGORY_1_UNIQUE_COLORS = {
    1: sky,
    2: orange,
    3: teal,
    4: purple,
    5: yellow,
    6: magenta,
    7: cyan,
    8: green,
    9: pink,
    10: indigo,
    11: lime,
    12: red
};
/** @deprecated use data vis colors instead */
export const CATEGORY_1_UNIQUE_LIGHT_COLORS = {
    1: sky_300,
    2: orange_200,
    3: teal_300,
    4: purple_200,
    5: yellow_200,
    6: magenta_300,
    7: cyan_200,
    8: green_200,
    9: pink_200,
    10: indigo_300,
    11: lime_200,
    12: red_300
};
/** @deprecated use data vis colors instead */
export const CATEGORY_1_UNIQUE_DARK_COLORS = {
    1: sky_600,
    2: orange_500,
    3: teal_500,
    4: purple_600,
    5: yellow_400,
    6: magenta_700,
    7: cyan_400,
    8: green_500,
    9: pink_600,
    10: indigo_600,
    11: lime_500,
    12: red_600
};
/** @deprecated use data vis colors instead */
export const CATEGORY_2_SHIFT_LIGHT_COLORS = {
    1: teal,
    2: orange,
    3: purple,
    4: magenta,
    5: indigo,
    6: yellow,
    7: teal_300,
    8: orange_200,
    9: purple_200,
    10: magenta_300,
    11: indigo_300,
    12: yellow_200
};
/** @deprecated use data vis colors instead */
export const CATEGORY_2_SHIFT_DARK_COLORS = {
    1: teal,
    2: orange,
    3: purple,
    4: magenta,
    5: indigo,
    6: yellow,
    7: teal_500,
    8: orange_500,
    9: purple_600,
    10: magenta_700,
    11: indigo_600,
    12: yellow_400
};
/** @deprecated use data vis colors instead */
export const CATEGORY_2_UNIQUE_COLORS = {
    1: teal,
    2: orange,
    3: purple,
    4: magenta,
    5: indigo,
    6: yellow,
    7: green,
    8: cyan,
    9: pink,
    10: lime,
    11: red,
    12: sky
};
/** @deprecated use data vis colors instead */
export const CATEGORY_2_UNIQUE_LIGHT_COLORS = {
    1: teal_300,
    2: orange_200,
    3: purple_200,
    4: magenta_300,
    5: indigo_300,
    6: yellow_200,
    7: green_200,
    8: cyan_200,
    9: pink_200,
    10: lime_200,
    11: red_300,
    12: sky_300
};
/** @deprecated use data vis colors instead */
export const CATEGORY_2_UNIQUE_DARK_COLORS = {
    1: teal_500,
    2: orange_500,
    3: purple_600,
    4: magenta_700,
    5: indigo_600,
    6: yellow_400,
    7: green_500,
    8: cyan_400,
    9: pink_600,
    10: lime_500,
    11: red_600,
    12: sky_600
};
//# sourceMappingURL=category_palette.js.map